import { CardTitle } from "@/components/ui/card";

type CardTitleWithIconProps = {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
};

export default function CardTitleWithIcon({
  icon: Icon,
  title,
}: CardTitleWithIconProps) {
  return (
    <CardTitle className="flex items-center gap-3 text-lg">
      <div className="flex items-center justify-center w-10 h-10 rounded-full shrink-0 bg-muted">
        <Icon className="w-5 h-5" />
      </div>
      {title}
    </CardTitle>
  );
}
